module.exports = __webpack_public_path__ + "img/sec4_box4.6b4aebc6.png";